import {Component, Inject, Input} from 'ng-metadata/core';
import {JwtUtilService} from "../../../../security/jwtUtil.service";

@Component({
    "selector": "prm-service-no-offer-found",
    templateUrl: 'components/search/fullView/ngrs/noOfferFound/noOfferFound.html'
})

export class PrmServiceNoOfferFound{
    private offerFound: boolean = false;
    constructor (private jwtUtilService: JwtUtilService){       
    }

    ngOnInit(){
    }

    public isSignedIn(){
        let isUser = this.jwtUtilService.getDecodedToken().userGroup;
        if (isUser === 'GUEST'){
            return false;
        }
        return true;
    }

}








// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/noOfferFound/noOfferFound.directive.ts